import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

import PropTypes from "prop-types";
import SuiBox from "components/SuiBox";
import DashboardLayout from "custom/LayoutContainers/DashboardLayout";
import DashboardNavbar from "custom/Navbars/DashboardNavbar";
import Alert from "custom/Alert";
import { connect } from "react-redux";
import QuizDetails from "../components/quiz-details";

const NewQuiz = ({ redirectTo }) => {
  const history = useHistory();

  useEffect(() => {
    if (redirectTo && redirectTo !== "" && redirectTo !== "/quiz/new") {
      history.push(redirectTo);
    }
    // eslint-disable-next-line
  }, [redirectTo]);

  return (
    <>
      <Alert />
      <DashboardLayout>
        <DashboardNavbar />
        <SuiBox mt={3} mb={8}>
          <QuizDetails />
        </SuiBox>
      </DashboardLayout>
    </>
  );
};

NewQuiz.defaultProps = {
  redirectTo: "",
};

NewQuiz.propTypes = {
  redirectTo: PropTypes.string,
};

const mapStateToProps = (state) => ({
  redirectTo: state.ui.redirectTo,
});

export default connect(mapStateToProps, null)(NewQuiz);
